import { render, staticRenderFns } from "./PDataLine.vue?vue&type=template&id=b9b7f75a&scoped=true"
import script from "./PDataLine.vue?vue&type=script&lang=ts"
export * from "./PDataLine.vue?vue&type=script&lang=ts"
import style0 from "./PDataLine.vue?vue&type=style&index=0&id=b9b7f75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7f75a",
  null
  
)

export default component.exports